// extracted by mini-css-extract-plugin
module.exports = {"container":"betslipStakeInput__container___2370g","list":"betslipStakeInput__list___txQE6"};